class AudioService {
  static emitSound(sound) {
    var audio = new Audio(sound)
    audio.volume = 0.2
    audio.play()
  }
}

export default AudioService